<template>
    <div>
        <span class="coupon-label">
            {{ $t('coupon.date') }}
        </span>
        <span>{{ date }}</span>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { formatDatefromJsDate, stringDate } from '@/utils';

export default {
    name: 'coupon-appt-date',
    props: {
        appointment: { type: Object, required: true },
    },
    computed: {
        ...mapGetters({
            locale: 'locale',
        }),

        /**
         * Returns appointment's formatted date
         */
        date() {
            return this.appointment
                ? stringDate(formatDatefromJsDate(this.appointment.start), this.locale)
                : '';
        },
    },
};
</script>

<style lang="scss" scoped>

</style>
